export default __webpack_public_path__ + "static/Unassembled_TEK_Hover_Skiff-8181bc8f2509ab326cbdc077a96fe0a9.png";